var _g, _rect, _rect2, _line, _g2, _rect3, _g3, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path2, _path3, _path4, _path5, _path6, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450,
    height: 140,
    viewBox: "0 0 490 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1_149430)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.828,
    y: 85.5115,
    width: 7.58343,
    height: 18.116,
    rx: 3.79171,
    fill: "#E47373"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 210.671,
    y: 86.3541,
    width: 5.89822,
    height: 16.4308,
    rx: 2.94911,
    stroke: "#C52828",
    strokeWidth: 1.68521
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 279.342,
    y: 86.3541,
    width: 5.89822,
    height: 16.4308,
    rx: 2.94911,
    fill: "#E47373",
    stroke: "#C52828",
    strokeWidth: 1.68521
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 248.169,
    y1: 56.8619,
    x2: 248.169,
    y2: 71.6074,
    stroke: "#C52828",
    strokeWidth: 1.68521
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1_149430)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 238.9,
    y: 64.4452,
    width: 18.5373,
    height: 10.9538,
    rx: 5.47692,
    fill: "#E47373"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 239.743,
    y: 65.2878,
    width: 16.8521,
    height: 9.26863,
    rx: 4.63432,
    stroke: "#C52828",
    strokeWidth: 1.68521
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1_149430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.621 93.5156C213.621 80.7183 223.995 70.344 236.793 70.344H259.122C271.919 70.344 282.293 80.7183 282.293 93.5156V104.469C282.293 110.752 277.2 115.845 270.918 115.845H224.996C218.714 115.845 213.621 110.752 213.621 104.469V93.5156Z",
    fill: "#E47373"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214.464 93.5156C214.464 81.1836 224.461 71.1866 236.793 71.1866H259.122C271.454 71.1866 281.451 81.1836 281.451 93.5156V104.469C281.451 110.286 276.735 115.002 270.918 115.002H224.996C219.179 115.002 214.464 110.286 214.464 104.469V93.5156Z",
    stroke: "#C52828",
    strokeWidth: 1.68521
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 233.421,
    cy: 86.3544,
    r: 8.42603,
    fill: "white",
    stroke: "#C52828",
    strokeWidth: 1.68521
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.42,
    cy: 86.3541,
    r: 4.21301,
    fill: "#430202",
    stroke: "#C52828",
    strokeWidth: 0.842603
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 231.736,
    cy: 85.5115,
    r: 1.2639,
    fill: "white",
    stroke: "#C52828",
    strokeWidth: 0.842603
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.072,
    cy: 86.3544,
    r: 8.42603,
    fill: "white",
    stroke: "#C52828",
    strokeWidth: 1.68521
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.071,
    cy: 86.3541,
    r: 4.42366,
    fill: "#430202",
    stroke: "#C52828",
    strokeWidth: 0.421301
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 260.387,
    cy: 85.5115,
    r: 1.47455,
    fill: "white",
    stroke: "#C52828",
    strokeWidth: 0.421301
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256.173 105.997C252.803 99.4666 243.324 99.4666 239.743 105.997",
    stroke: "#C52828",
    strokeWidth: 1.68521,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M248.692 46.7933H248.31C245.863 46.7933 243.834 45.0507 243.692 42.8262L242.403 22.7568C242.329 21.6036 242.785 20.4605 243.656 19.6202C244.526 18.7798 245.753 18.2979 247.021 18.2979H249.981C251.249 18.2979 252.476 18.7798 253.346 19.6201C254.217 20.4604 254.673 21.6037 254.6 22.7568L253.311 42.8262C253.168 45.0508 251.139 46.7933 248.692 46.7933Z",
    fill: "#EB9696"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M248.692 46.7933C251.139 46.7933 253.168 45.0508 253.311 42.8262L254.599 22.7568C254.673 21.6036 254.217 20.4604 253.346 19.6201C252.476 18.7798 251.249 18.2979 249.981 18.2979H248.501V46.7933H248.692Z",
    fill: "#E47373"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M248.501 56.9702C246.256 56.9702 244.43 55.144 244.43 52.8995C244.43 50.6548 246.256 48.8286 248.501 48.8286C250.746 48.8286 252.572 50.6548 252.572 52.8994C252.572 55.144 250.746 56.9702 248.501 56.9702Z",
    fill: "#EB9696"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M248.501 48.8286V56.9702C250.746 56.9702 252.572 55.144 252.572 52.8994C252.572 50.6548 250.746 48.8286 248.501 48.8286Z",
    fill: "#E47373"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.515 87.1317C174.671 87.1317 172.877 86.1794 171.88 84.4715C167.57 77.0796 165.291 68.6384 165.291 60.0606C165.291 51.4824 167.57 43.0411 171.88 35.6496C173.371 33.0931 176.653 32.2277 179.21 33.7201C181.767 35.2112 182.631 38.4926 181.14 41.0499C177.784 46.8042 176.01 53.3779 176.01 60.0606C176.01 66.7429 177.784 73.3169 181.14 79.0713C182.631 81.6281 181.767 84.9099 179.21 86.4013C178.361 86.8962 177.432 87.1317 176.515 87.1317Z",
    fill: "#E43A35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.986 97.8994C156.141 97.8994 154.347 96.9472 153.351 95.2393C147.139 84.5874 143.856 72.4237 143.856 60.0624C143.856 47.7011 147.139 35.5374 153.351 24.8859C154.842 22.329 158.123 21.4647 160.681 22.9561C163.238 24.4474 164.102 27.7289 162.61 30.2861C157.353 39.3002 154.575 49.5966 154.575 60.0624C154.575 70.5282 157.353 80.8246 162.61 89.839C164.101 92.3959 163.238 95.6777 160.681 97.1691C159.831 97.664 158.902 97.8994 157.986 97.8994Z",
    fill: "#E47373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.422 108.681C137.576 108.681 135.781 107.727 134.785 106.017C126.692 92.1149 122.414 76.2242 122.414 60.0616C122.414 43.8996 126.692 28.0082 134.785 14.1066C136.274 11.5486 139.555 10.6815 142.113 12.1714C144.671 13.6607 145.538 16.9418 144.049 19.4997C136.908 31.766 133.133 45.7919 133.133 60.0616C133.133 74.3312 136.908 88.3571 144.049 100.623C145.538 103.181 144.672 106.462 142.113 107.951C141.265 108.445 140.337 108.681 139.422 108.681Z",
    fill: "#FECDD2"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.17 32.5944C319.014 32.5944 320.808 33.5466 321.805 35.2545C326.116 42.6464 328.394 51.0877 328.394 59.6655C328.394 68.2437 326.116 76.685 321.805 84.0765C320.314 86.633 317.033 87.4984 314.475 86.0059C311.918 84.5149 311.054 81.2334 312.545 78.6762C315.901 72.9218 317.675 66.3482 317.675 59.6655C317.675 52.9832 315.901 46.4092 312.545 40.6548C311.054 38.098 311.918 34.8161 314.475 33.3247C315.324 32.8299 316.253 32.5944 317.17 32.5944Z",
    fill: "#E43A35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.696 21.8267C337.541 21.8267 339.335 22.7789 340.331 24.4868C346.542 35.1387 349.826 47.3024 349.826 59.6637C349.826 72.025 346.542 84.1887 340.331 94.8402C338.84 97.3971 335.558 98.2614 333.001 96.77C330.444 95.2787 329.58 91.9972 331.071 89.44C336.328 80.4259 339.107 70.1295 339.107 59.6637C339.107 49.1979 336.328 38.9015 331.071 29.8871C329.58 27.3302 330.444 24.0484 333.001 22.557C333.85 22.0621 334.779 21.8267 335.696 21.8267Z",
    fill: "#E47373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.26 11.0455C356.105 11.0455 357.901 11.9995 358.897 13.7096C366.99 27.6112 371.268 43.5019 371.268 59.6645C371.268 75.8264 366.99 91.7179 358.897 105.619C357.407 108.177 354.126 109.045 351.568 107.555C349.01 106.065 348.144 102.784 349.633 100.226C356.774 87.9601 360.548 73.9342 360.548 59.6645C360.548 45.3949 356.774 31.3689 349.633 19.103C348.144 16.5451 349.01 13.264 351.568 11.7748C352.416 11.281 353.344 11.0455 354.26 11.0455Z",
    fill: "#FECDD2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1_149430",
    x: 209.828,
    y: 85.5115,
    width: 7.5835,
    height: 18.116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.37041,
    dy: 1.2639
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_149430"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1_149430",
    x: 238.9,
    y: 64.4452,
    width: 18.5371,
    height: 10.9538,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.37041,
    dy: 1.2639
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_149430"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1_149430",
    x: 213.621,
    y: 70.344,
    width: 68.6724,
    height: 45.5005,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.37041,
    dy: 1.2639
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_149430"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveStatus);
export default __webpack_public_path__ + "static/media/InactiveStatus.9368534d50d33ac9834c296c377b2613.svg";
export { ForwardRef as ReactComponent };